import React from 'react';
import {
  ISliceNameHint,
  ITopPathsSliceFieldsFragment,
} from '../../../utils/apollo/graphqlSchema';
import { getOverallConversion } from './funnelUtils';
import { formatNumberWithComma } from '../../../utils/formatText';
import {
  defaultNumberFormatOptions,
  globalFormat,
} from '../../../utils/formatting';
import TopPathFunnelChart from './TopPathFunnelChart';
import { ChartMode } from '../types';

export interface ITopPathAndSlice {
  topPath: ITopPathsSliceFieldsFragment['topPaths'][number];
  belongingSlice: ITopPathsSliceFieldsFragment;
}

export type LabelFunction = (hint: ISliceNameHint[]) => string;

interface ITopPathGroupProps {
  topPaths: ITopPathAndSlice[];
  labelFunction: LabelFunction;
  mode: ChartMode;
}

export const TopPathsGroup = ({
  topPaths,
  labelFunction,
  mode,
}: ITopPathGroupProps) => {
  const elements = topPaths.map(
    ({ belongingSlice, topPath: path }, chartIndex) => {
      const funnel = path.funnel;
      const { value: conversionValue, percent: conversionPercent } =
        getOverallConversion(funnel);
      const percentHuman = globalFormat.formatNumber(
        conversionPercent,
        defaultNumberFormatOptions.percent,
      );
      const valueHuman = formatNumberWithComma(conversionValue);

      const showChartDivider = chartIndex > 0;
      const transientFunnelAnalysisId = funnel.id;

      return (
        <TopPathFunnelChart
          key={transientFunnelAnalysisId}
          transientFunnelAnalysisId={transientFunnelAnalysisId}
          rankLabel={path.rank.toString(10)}
          humanLabel={`${percentHuman} (${valueHuman})`}
          label={labelFunction(belongingSlice.hint)}
          showChartDivider={showChartDivider}
          mode={mode}
        />
      );
    },
  );
  return <>{elements}</>;
};
